import type { ButtonVariant, ButtonColor } from './types'

/**
 * Button variant constants
 */
export const BUTTON_VARIANTS = {
  FILLED: 'filled',
  OUTLINED: 'outlined',
  TONAL: 'tonal',
  PLAIN: 'plain',
} as const

/**
 * Button size constants
 */
export const BUTTON_SIZES = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
} as const

/**
 * Button color constants
 */
export const BUTTON_COLORS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  NEUTRAL: 'neutral',
  DESTRUCTIVE: 'destructive',
} as const

/**
 * Valid variant/color combinations per design system
 */
export const VALID_COMBINATIONS: Record<ButtonVariant, readonly ButtonColor[]> = {
  filled: ['primary', 'destructive'] as const,
  outlined: ['primary', 'neutral', 'destructive'] as const,
  tonal: ['primary', 'neutral', 'destructive', 'secondary'] as const,
  plain: ['primary', 'secondary', 'neutral', 'destructive'] as const,
} as const
